import React, { useState, useEffect } from "react";

import CountryInput from "./CountryInput";
import StateInput from "./StateInput";

// MembershipForm component; displays the payment info and billing address
const MembershipPaymentForm = (props) => {
    const {acfData, finalTotal, checkoutObject, setCheckoutObject, setActiveScreen} = props;
    
    const [expDate, setExpDate] = useState({month: '', year: ''});
    const [confirmEmail, setConfirmEmail] = useState('');
    const [formIsFilled, setFormIsFilled] = useState(false);
    const [formHasErrors, setFormHasErrors] = useState(false);
    
    const nextTenYears = [];
    let currentYear = new Date().getFullYear();
    for (let i = 0; i <= 10; i++) {
        nextTenYears.push(<option value={currentYear + i}>{currentYear + i}</option>);
    }

    const months = [];
    for (let j = 1; j <= 12; j++) {
        months.push(<option value={j.toString().padStart(2, '0')}>{j.toString().padStart(2, '0')}</option>)
    }

    function handleChange(e) {
        setCheckoutObject({...checkoutObject, [e.target.dataset.key]: e.target.value});

        if (formHasErrors) {
            validateForm();
        }
    }

    function handleEmail(value) {
        setConfirmEmail(value);
        if (formHasErrors) {
            validateForm();
        }
    }

    function validateForm() {
        setFormHasErrors(false);
        let errorFlag = false;
        document.querySelectorAll('.payment-form input').forEach(field => {
            if (field.value.search(field.dataset.pattern) === -1) {
                errorFlag = true;
                field.classList.add('error');
            } else {
                field.classList.remove('error');
            }

            // check if email address matches confirmation field
            if (field.id === 'confirm-email') {
                if (field.value !== checkoutObject?.billingEmail) {
                    errorFlag = true;
                    field.classList.add('error');
                } else {
                    field.classList.remove('error');
                }
            }
        });

        document.querySelectorAll('.payment-form select').forEach(field => {
            if (field.value == 'false') {
                errorFlag = true;
                field.classList.add('error');
            } else {
                field.classList.remove('error');
            }
        });

        setFormHasErrors(errorFlag);

        if (!errorFlag) {
            submitForm();
        }
    }

    function submitForm() {
        if (!formHasErrors) {
            setActiveScreen('summary');
            window.scrollTo(0, 200);
        }
    }

    useEffect(() => {
        if (expDate.month != '' && expDate.year != '') {
            setCheckoutObject({...checkoutObject, 'expDate': expDate.month + expDate.year.slice(-2)})
        } else {
            setCheckoutObject({...checkoutObject, 'expDate': ''})
        }
    }, [expDate]);

    useEffect(() => {
        let flag = true;
        for (const objKey in checkoutObject) {
            if (objKey == 'billingAddress2' || objKey == 'shoppingCart' || objKey == 'couponCodes' || objKey == 'saleChannel') {
                continue;
            }
            
            if (checkoutObject[objKey] == null || checkoutObject[objKey].length < 2) {
                flag = false;
            }

            if (confirmEmail !== checkoutObject.billingEmail) {
                flag = false;
            }
        }
        setFormIsFilled(flag);
    }, [checkoutObject, confirmEmail]);

    return (
        <>
            <form className="payment-form">
                <h5>Credit / Debit Card Info</h5>
                <fieldset>
                    <div className="fieldgroup fieldgroup--columns">
                        <label htmlFor="payment-first-name">First and last name</label>
                        <input type="text" id="payment-first-name" placeholder="First" data-pattern="\w{2,}" value={checkoutObject.billingFirstName} data-key="billingFirstName" onChange={(e) => handleChange(e)}/>
                        <label htmlFor="payment-last-name" className="sr-only">Last Name</label>
                        <input type="text" id="payment-last-name" placeholder="Last" data-pattern="\w{2,}" value={checkoutObject.billingLastName} data-key="billingLastName" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="card-number">Card number</label>
                        <input type="text" id="card-number" data-pattern="\d{15,16}" value={checkoutObject.manualEntryCardNumber} data-key="manualEntryCardNumber" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="security-code">Security code (CVC)</label>
                        <input type="text" id="security-code" data-pattern="\d{3,4}" value={checkoutObject.cvc} data-key="cvc" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup fieldgroup--columns">
                        <label htmlFor="month">Expiration date</label>
                        <select id="month" onChange={(e) => setExpDate({...expDate, 'month': e.target.value})}>
                            <option value="">MM</option>
                            {months}
                        </select>
                        <select onChange={(e) => setExpDate({...expDate, 'year': e.target.value})}>
                            <option value="">YYYY</option>
                            {nextTenYears}
                        </select>
                    </div>
                </fieldset>
                <h5>Billing Address</h5>
                {acfData && acfData.acf.billing_address_note != undefined && acfData.acf.billing_address_note.length > 0 && <p>{acfData.acf.billing_address_note}</p>}
                <fieldset>
                    <div className="fieldgroup">
                        <label htmlFor="billing-street-address">Street address</label>
                        <input type="text" id="billing-street-address" data-pattern=".{2,}" value={checkoutObject.billingAddress1} data-key="billingAddress1" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="billing-street-address-2">Street address 2 (optional)</label>
                        <input type="text" id="billing-street-address-2" value={checkoutObject.billingAddress2} data-key="billingAddress2" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="billing-city">City</label>
                        <input type="text" id="billing-city" data-pattern="\w{2,}" value={checkoutObject.billingCity} data-key="billingCity" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="billing-state">State/Province</label>
                        <StateInput id="billing-state" value={checkoutObject.billingState} country={checkoutObject.billingCountry} data-key="billingState" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="billing-zip">ZIP/Postal code</label>
                        <input type="text" id="billing-zip" data-pattern=".{5,}" value={checkoutObject.billingZipCode} data-key="billingZipCode" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="billing-country">Country</label>
                        <CountryInput id="billing-country" value={checkoutObject.billingCountry} data-key="billingCountry" onChange={(e) => handleChange(e)} />
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="billing-phone">Phone number</label>
                        <input type="tel" id="billing-phone" data-pattern="^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$" value={checkoutObject.billingPhoneNumber} data-key="billingPhoneNumber" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="billing-email">Email address</label>
                        <input type="email" id="billing-email" data-pattern="^[^@]+@[^@]+\.[^@\.]{2,}$" value={checkoutObject.billingEmail} data-key="billingEmail" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className="fieldgroup">
                        <label htmlFor="confirm-email">Confirm email address</label>
                        <input className={checkoutObject.billingEmail?.length > 0 && confirmEmail?.length > 0 && checkoutObject?.billingEmail != confirmEmail ? 'error' : ''} type="email" id="confirm-email" data-pattern="^[^@]+@[^@]+\.[^@\.]{2,}$" value={confirmEmail} onChange={(e) => handleEmail(e.target.value)} />
                    </div>
                </fieldset>
            </form>
            <hr/>
            <div className="membership__total">
                <span className="membership__total-title">
                    Total
                </span>
                <span className="membership__total-amount">
                    ${finalTotal}
                </span>
            </div>
            {formHasErrors && <p className="payment-form__error-text"><i className="fa fa-warning"></i>Please correct missing or incorrect information.</p>}
            <button
                className="ticket-summary__next button"
                disabled={!formIsFilled || formHasErrors}
                onClick={() => validateForm()}
            >
                Review Your Order
            </button>
        </>
    );
}

export default MembershipPaymentForm;